'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

DashboardConfig=class DashboardConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('dashboard',{
url:'/dashboard?groupId&{dashboardMainTabSelection:int}',
reloadOnSearch:!1});

$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=DashboardConfig;
//# sourceMappingURL=dashboardConfig.js.map
